import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { formatDateWithoutHour } from 'app/utils/dates';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS as HOTEL_QUERY_KEYS } from '../hotel';
import { CORE_QUERY_KEYS as INVENTORY_CORE_QUERY_KEYS } from '../inventory';

import { ENDPOINTS } from '.';
import type { UpdatePackConfigurationRequest } from './mapping/pack';

type PayloadProps = {
  packId: number;
  hotelId: number;
  openingConfiguration: UpdatePackConfigurationRequest | null;
};

export function useSavePackConfiguration(currentRange?: {
  startDate: Date;
  endDate: Date;
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: PayloadProps) =>
      apiMutation(
        'PATCH',
        {
          path: ENDPOINTS.updatePackConfiguration,
          params: {
            id: payload.hotelId.toString(),
            packId: payload.packId.toString(),
          },
        },
        { openingConfiguration: payload.openingConfiguration }
      ) as Promise<void>,
    onSuccess: (_, payload) => {
      queryClient.invalidateQueries({
        queryKey: [HOTEL_QUERY_KEYS.hotelPacks, { id: payload.hotelId }],
      });

      queryClient.invalidateQueries({
        queryKey: [
          INVENTORY_CORE_QUERY_KEYS.inventory,
          {
            hotelId: payload.hotelId,
            startDate: formatDateWithoutHour(
              currentRange?.startDate ?? new Date()
            ),
            endDate: formatDateWithoutHour(currentRange?.endDate ?? new Date()),
          },
        ],
      });

      queryClient.invalidateQueries({
        queryKey: [
          INVENTORY_CORE_QUERY_KEYS.packScore,
          { hotelId: payload.hotelId },
        ],
      });
    },
    onError: (_, payload) => {
      message.error(`Error while modifying package #${payload.packId}`);
    },
  });
}
